import {styled} from "@mui/material/styles";
import { Button, StepLabel, Stepper } from '@mui/material';
import { useColors } from "../../../Context/ColorsContext";

export const Wizard = styled(Stepper)(({theme}) => ({
    '.MuiStepLabel-label': {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#adb4bb',
        '&.Mui-active': {
            color: '#3a424f',
        },
        '&.Mui-completed': {
            color: '#3a424f',
        }
    },
    '.MuiStepConnector-root': {
        left: 'calc(-50% + 40px)',
        right: 'calc(50% + 40px)',
    },
    marginTop: 0,
    marginBottom: 3,
    paddingTop: 3,
	paddingLeft: '6rem',
	paddingRight: '6rem',
	[theme.breakpoints.down('sm')]: {
		paddingLeft: '1rem',
		paddingRight: '1rem',
	}
}))

export const CustomStepLabel = styled(StepLabel)(({theme}) => ({
	fontWeight: 'bold !important',
    '.MuiStepLabel-label': {
		lineHeight: 1.1,
        fontSize: 14,
        fontWeight: 'bold !important',
        color: '#adb4bb',
        '&.Mui-active': {
            color: '#3a424f',
        },
        '&.Mui-completed': {
            color: '#3a424f',
        }
    },
	'& .MuiStepLabel-label': {
		marginTop: '4px !important',
		fontWeight: 'bold !important'
	},
	[theme.breakpoints.down('sm')]: {
		'.MuiStepLabel-label': {
        	fontSize: '12px !important',
		}
	},
}))

export const CustomButton = styled(Button)(({type}) => {
    const { colors } = useColors();
    const nextButton = '#1976d2';
    const backButtonText = 'rgba(0, 0, 0, 0.5)';
    const backButtonBorder = 'rgba(0, 0, 0, 0.2)';
    const backButtonBg = '#F0F0F0';
    return {
        minWidth: 90,
        backgroundColor: type === 'back' ? backButtonBg : nextButton,
        color: type === 'back' ? backButtonText : colors.white,
        border: `1px solid ${type === 'back' ? backButtonBorder : nextButton}`,
        "&:hover": {
            backgroundColor: type === 'back' ? backButtonBg : nextButton,
            opacity: 0.8,
            color: type === 'back' ? backButtonText : colors.white
        }
    }
})